import React, { useState } from 'react';
import SignaturePad from '../../../utils/SignaturePad';
const SignatureSection = ({ data, onChange }) => {
  const [signatures, setSignatures] = useState({
    applicantSignature: data?.applicantSignature || '',
    caregiverSignature: data?.caregiverSignature || '',
    hrSignature: data?.hrSignature || '',
    acknowledgesDuties: data?.acknowledgesDuties || false
  });

  const handleSignatureChange = (e) => {
    const { name, value } = e.target;
    const updatedSignatures = { ...signatures, [name]: value };
    setSignatures(updatedSignatures);
    
    if (onChange) {
      onChange(updatedSignatures);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const updatedSignatures = { ...signatures, [name]: checked };
    setSignatures(updatedSignatures);
    
    if (onChange) {
      onChange(updatedSignatures);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Signatures & Acknowledgments
      </h3>
      
      <div className="space-y-6">
        {/* Applicant Signature */}
        <SignaturePad
          label="Applicant Signature"
          name="applicantSignature"
          value={signatures.applicantSignature}
          onChange={handleSignatureChange}
          required={true}
        />
        
        {/* Caregiver Signature */}
        <SignaturePad
          label="Caregiver Signature"
          name="caregiverSignature"
          value={signatures.caregiverSignature}
          onChange={handleSignatureChange}
          required={true}
        />
        
        {/* HR Signature */}
        <SignaturePad
          label="HR Signature"
          name="hrSignature"
          value={signatures.hrSignature}
          onChange={handleSignatureChange}
          required={true}
        />
        
        {/* Acknowledgment Checkbox */}
        <div className="mt-4 pt-4 border-t border-gray-200">
          <label className="flex items-start space-x-3">
            <input
              type="checkbox"
              name="acknowledgesDuties"
              checked={signatures.acknowledgesDuties}
              onChange={handleCheckboxChange}
              className="mt-1 h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700">
              I acknowledge that I have read, understood, and agree to all duties and responsibilities outlined in this document.
            </span>
          </label>
        </div>
      </div>
      
      {/* Signature Status */}
      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <p className="text-sm text-gray-600">
          Signature Status:
        </p>
        <ul className="mt-2 space-y-1">
          <li className="flex items-center text-sm">
            <span className={`w-2 h-2 rounded-full mr-2 ${signatures.applicantSignature ? 'bg-green-500' : 'bg-red-500'}`}></span>
            Applicant: {signatures.applicantSignature ? 'Signed' : 'Pending'}
          </li>
          <li className="flex items-center text-sm">
            <span className={`w-2 h-2 rounded-full mr-2 ${signatures.caregiverSignature ? 'bg-green-500' : 'bg-red-500'}`}></span>
            Caregiver: {signatures.caregiverSignature ? 'Signed' : 'Pending'}
          </li>
          <li className="flex items-center text-sm">
            <span className={`w-2 h-2 rounded-full mr-2 ${signatures.hrSignature ? 'bg-green-500' : 'bg-red-500'}`}></span>
            HR: {signatures.hrSignature ? 'Signed' : 'Pending'}
          </li>
          <li className="flex items-center text-sm">
            <span className={`w-2 h-2 rounded-full mr-2 ${signatures.acknowledgesDuties ? 'bg-green-500' : 'bg-red-500'}`}></span>
            Acknowledgment: {signatures.acknowledgesDuties ? 'Confirmed' : 'Pending'}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SignatureSection;